// This is being used for the drag and drop functionality in the data pipelines index page and the tasks show page
import {Controller} from "@hotwired/stimulus"
import Sortable from "sortablejs";

export default class extends Controller {
    connect() {
        this.sortable = Sortable.create(this.element, {
            onEnd: this.end.bind(this)
        })
    }

    end(event) {
        let id = event.item.dataset.id
        let data = new FormData()
        data.append("position", event.newIndex + 1)

        const plainFormData = Object.fromEntries(data.entries());
        const formDataJsonString = JSON.stringify(plainFormData);

        // Get CSRF token from meta tag
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        fetch(this.data.get("url").replace(":id", id), {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-CSRF-Token": csrfToken
            },
            method: "PATCH",
            body: formDataJsonString,
        })
    }
}
